import { RM_ASSOCIATION_CRUD_ACTION_CREATORS } from '../actions/rm_association_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import FetchUtils, { parseJSON } from './fetch_utils';

const fetchUtils = new FetchUtils();

export const rmAssociationRestCrudThunksForBuyer = new RestCrudThunks(
	'rm_category',
	'rm_category',
	'rm_category',
	'rm_category',
	RM_ASSOCIATION_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'associations/'
);

export const rmAssociationRestCrudThunksForSupplier = new RestCrudThunks(
	'rm_category',
	'rm_category',
	'rm_category',
	'rm_category',
	RM_ASSOCIATION_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'associations/'
);

export const deleteRmCategoryAssociation = (roleType) => (id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/associations/rm_category/${id}`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.delete(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
